import { render, staticRenderFns } from "./activeDataKanban.vue?vue&type=template&id=63920a4d&scoped=true&"
import script from "./activeDataKanban.vue?vue&type=script&lang=js&"
export * from "./activeDataKanban.vue?vue&type=script&lang=js&"
import style0 from "./activeDataKanban.vue?vue&type=style&index=0&id=63920a4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63920a4d",
  null
  
)

component.options.__file = "activeDataKanban.vue"
export default component.exports